import { render, staticRenderFns } from "./UserModulesDialog.vue?vue&type=template&id=40c3ea6f&scoped=true"
import script from "./UserModulesDialog.vue?vue&type=script&lang=js"
export * from "./UserModulesDialog.vue?vue&type=script&lang=js"
import style0 from "./UserModulesDialog.vue?vue&type=style&index=0&id=40c3ea6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c3ea6f",
  null
  
)

export default component.exports